<template>
  <div class="signUpForm">
    <p class="redColorTitle">请尽快上传完赛证明，否则无法取得完赛证书</p>
    <van-form @submit="onSubmit">
      <!-- 姓名 -->
      <van-field
        v-model="form.matchName"
        name="name"
        label="赛事名称"
        placeholder="赛事名称"
        required
        disabled
      />

      <!-- 完赛证书 -->
      <van-field name="uploader" label="完赛证明">
        <template #input>
          <van-uploader
            v-model="uploader"
            max-count="1"
            :after-read="afterRead"
            result-type="dataUrl"
          />
        </template>
      </van-field>

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit"
          >上传完赛证明</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import { fetchHttp } from "@/util/fn.js";

import { Button, Form, Field, Uploader, SubmitBar, Toast } from "vant";
import { getQueryString } from "../util/fn";

export default {
  name: "UserForm",
  props: {
    originForm: Object,
  },
  components: {
    [Button.name]: Button,
    [Form.name]: Form,
    [Field.name]: Field,
    [Uploader.name]: Uploader,
    [SubmitBar.name]: SubmitBar,
  },
  data() {
    return {
      userId: getQueryString("userId"),
      uploader: [],
      form: {
        matchName: getQueryString("matchName"),
        url: "", //完赛证书
        projectId: getQueryString("projectId"),
        matchId: getQueryString("matchId")
      },
    };
  },
  mounted() {},
  methods: {
    //表单验证通过时的提交
    onSubmit(values) {
      console.log("form 中的数据", values);

      let url = values.uploader && values.uploader[0] && values.uploader[0].url;
      //校验健康证明
      if (!url) {
        Toast.fail("请上传一年内完赛证书！");
        return;
      }

      let postData = Object.assign(this.form, {
        userId: this.userId,
        url: values.uploader[0].url
      });

      console.log("提交数据", postData);

      fetchHttp("marathon/result/onLinePicture", postData, "GET").then(
        (res) => {
          if (res && res.code === 0) {
            Toast.success("上传完赛证明成功，请耐心等待审核！");
            setTimeout(() => {
              window.location.replace('myGame')
            }, 2000);
          } else {
            Toast.fail(res.message);
          }
        }
      );
    },

    // 完赛证的 文件上传
    afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";

      //处理请求参数
      let formData = new FormData();
      formData.append("file", file.file);

      let postUrl = "http://ccfmty.com/marathon/picture";

      let postData = {
        method: "POST",
        credentials: "include",
        headers: {
          Accept: "*/*",
          token: Cookies.get("FMTY_TOKEN"),
        },
        body: formData,
      };
      let _self = this;
      window
        .fetch(postUrl, postData)
        .then(function (response) {
          return response.json();
        })
        .then(function (res) {
          if (res.code === 0 && res.data) {
            let url = '';
            if( res.data && res.data.includes('马拉松') ){
              url =  "http://ccfmty.com/marathon" + res.data;
            }else{
              url = res.data;
            }
            _self.uploader = url ? [{ url: url }] : [];
          } else if (
            res.code === 300003 ||
            res.code === 300000 ||
            res.code === 300002
          ) {
            alert("请您先登录！");
            setTimeout(() => {
              window.location.href =
                "login" +
                "?redirect_url=" +
                encodeURIComponent(window.location.href);
            }, 2500);
          } else {
            file.status = "failed";
            file.message = "上传失败";
          }
        });
    },
  },
};
</script>
<style scoped>
.redColorTitle {
  color: red;
  font-size: 16px;
  padding-left: 10px;
}
</style>